// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/singleProduct';
// import IframeService from './services/iframeService';
import LightboxGallery from './services/LightboxGallery.js';
import { initReturnBackLogic } from './util/returnBack.js';
import { initBackToTopButton } from './util/backToTop.js';

initReturnBackLogic();
initBackToTopButton();

if (window.location.pathname === '/') {
  let tries = 0;
  const maxTries = 100;

  const removeDeepLElements = () => {
    const deeplSelectors = '[deepl-translate-input], deepl-input-controller, deepl-inline-trigger';
    const elements = document.querySelectorAll(deeplSelectors);

    if (elements.length > 0) {
      elements.forEach(el => {
        el.remove();
      });
      clearInterval(interval);
      return;
    }

    tries++;
    if (tries >= maxTries) {
      clearInterval(interval);
    }
  };

  const interval = setInterval(removeDeepLElements, 100);
}

// var swiper = new Swiper(".mySwiper", {
//   slidesPerView: 3,
//   centeredSlides: false,
//   spaceBetween: 30,
//   pagination: {
//     el: ".swiper-pagination",
//     type: "fraction",
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
// });

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  home,
  aboutUs,
  singleProduct,
});

document.addEventListener('DOMContentLoaded', () => {
  window.lightbox = new LightboxGallery();
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

const showMobileFiltersPopScrollUp = () => {
  let lastScrollTop = 0;
  let accumulatedScrollUp = 0;
  let accumulatedScrollDown = 0;
  const scrollThreshold = 150;

  // Function to check if the device is a phone
  const isPhone = () => {
    const maxWidth = 1024;
    const maxHeight = 600;
    return window.innerWidth <= maxWidth && window.innerHeight <= maxHeight;
  };

  const updateElementVisibility = () => {
    const mobileFilterPop = $('.mobile-filter-pop');
    const isLandscape = window.matchMedia("(orientation: landscape)").matches;

    if (isPhone() && isLandscape) {
      mobileFilterPop.removeClass('fixed');
    } else {
      if (accumulatedScrollUp >= scrollThreshold) {
        if ($(window).scrollTop() > 100) {
          mobileFilterPop.addClass('fixed');
        } else {
          mobileFilterPop.removeClass('fixed');
        }
      }
      if (accumulatedScrollDown >= scrollThreshold) {
        mobileFilterPop.removeClass('fixed');
      }
    }
  };

  $(window).on('scroll', function() {
    const scrollPosition = $(this).scrollTop();

    if (scrollPosition < lastScrollTop) {
      accumulatedScrollUp += (lastScrollTop - scrollPosition);
      accumulatedScrollDown = 0;
    } else {
      accumulatedScrollDown += (scrollPosition - lastScrollTop);
      accumulatedScrollUp = 0;
    }

    updateElementVisibility();

    lastScrollTop = scrollPosition;
  });

  // Function to handle window resize and remove 'fixed' class on phones
  const handleResize = () => {
    const mobileFilterPop = $('.mobile-filter-pop');
    if (isPhone()) {
      mobileFilterPop.removeClass('fixed');
    }
  };

  $(window).on('resize', handleResize); // Attach the resize event listener
  $(window).on('orientationchange', updateElementVisibility); // Update on orientation change
};

showMobileFiltersPopScrollUp();

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(event) {
    const button = event.target.closest('.demo-button');
    if (button) {
        event.preventDefault(); // Prevent default anchor behavior

        // Extract attributes
        const gameTitle = button.getAttribute('data-game-title');
        const videoLink = button.getAttribute('data-video-link');
        const description = button.getAttribute('data-demo-description');
        const gameContainer = button.closest('.game-listing-box');
        
        let listGameId = null;
        if (gameContainer && gameContainer.getAttribute('data-game-id')) {
            listGameId = gameContainer.getAttribute('data-game-id');
        } else if (document.getElementById('gameId')) {
            listGameId = document.getElementById('gameId').value;
        }

        // Perform the appropriate action based on the description
        if (description.trim() === '') {
            // IframeService.open(videoLink, listGameId); // Directly open the URL here
            window.location.href = videoLink; // Directly open the URL here
        } else {
            showPopup(gameTitle, videoLink, description, listGameId);
        }
    }
});

  document.addEventListener('click', function(event) {
      var popup = document.getElementById('popup');
      var popupContainer = document.getElementById('popupContainer');
      if ((popup && !popup.contains(event.target) || (popupContainer && !popupContainer.contains(event.target))) && !event.target.closest('.demo-button')) {
          closePopup();
      }
  });

  document.body.addEventListener('click', function(event) {
      if (event.target.closest('.pop-up-content')) {
          event.stopPropagation();
      } else if (event.target.id === 'closePopup' || event.target.id === 'close-popup-btn') {
        closePopup();
    }

  });
});

function showPopup(gameTitle, videoLink, description, gameId) {
  document.body.classList.add('active');
  document.documentElement.classList.add('active');
  document.getElementsByClassName('page-wrapper')[0].classList.add('blur');

  var popupContent = `
  <div id="popup" class="popup pop-up-container">
      <div class="pop-up-content" id="popupContainer">
        <span class="closeBtn" id="closePopup">&times;</span>
        <h2>${gameTitle}</h2><hr />
          <div class="pop-up-inner-content">
              <p>${description}</p>
              <div id="container" class="play-demo-btns">
                <a class="c-btn" id="play-demo-btn" href="${videoLink}">Play Demo</a>
              </div>
          </div>
      </div>
  </div>`;

  document.body.insertAdjacentHTML('beforeend', popupContent);

  var popup = document.getElementById('popup');
  popup.focus();

  document.getElementById('closePopup').addEventListener('click', closePopup);
  
  const closeButton = document.getElementById('close-popup-btn');

  if (closeButton) {
      closeButton.addEventListener('click', closePopup);
  }
  
  // IframeService.setupPlayButton(document.getElementById('play-demo-btn'), videoLink, gameId, closePopup);
}

function closePopup() {

  document.body.classList.remove('active');
  document.documentElement.classList.remove('active');
  document.getElementsByClassName('page-wrapper')[0].classList.remove('blur');

  var popup = document.getElementById('popup');
  if (popup) {
      popup.remove();
  }
}

if (document.body.classList.contains('client-login')) {
  const inputs = document.querySelectorAll('input, textarea');

  function setKeyboardOffset() {
      const keyboardOffset = 300; // Adjust based on the typical keyboard height
      document.documentElement.style.setProperty('--keyboard-offset', `${keyboardOffset}px`);
  }

  function resetBody() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      document.documentElement.style.setProperty('--keyboard-offset', '0px');
  }

  inputs.forEach(input => {
      input.addEventListener('focus', () => {
          document.body.dataset.scrollY = window.scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${window.scrollY}px`;
          document.body.style.overflow = 'hidden';
          document.body.style.width = '100%';
          setKeyboardOffset();
          document.body.classList.add('keyboard-open');
      });

      input.addEventListener('blur', () => {
          resetBody();
          document.body.classList.remove('keyboard-open');
          window.scrollTo(0, 0);
      });
  });

  window.addEventListener('scroll', () => {
      if (document.body.classList.contains('keyboard-open')) {
          document.body.dataset.scrollY = window.scrollY;
      }
  });

  window.addEventListener('resize', () => {
      if (!document.activeElement || !['input', 'textarea'].includes(document.activeElement.tagName.toLowerCase())) {
          resetBody();
      }
  });
}

function isRestrictedPage() {
  // Get the <body> element
  const body = document.body;

  // Check if the <body> element contains specific classes
  const restrictedClasses = ['client-login', 'client-forgot-password', 'client-new-activate'];
  
  return restrictedClasses.some(cls => body.classList.contains(cls));
}

// Initialize the script only on restricted pages
if (isRestrictedPage()) {

  // Apply CSS styles to prevent scrolling
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  document.documentElement.style.height = '100%';
  document.body.style.height = '100%';
  document.documentElement.style.margin = '0';
  document.body.style.margin = '0';

  // Prevent scrolling
  document.addEventListener('touchmove', function(event) {
    event.preventDefault();
  }, { passive: false });

  // Prevent scrolling with arrow keys and space bar
  window.addEventListener('keydown', function(event) {
    if (event.keyCode === 32 || (event.keyCode >= 37 && event.keyCode <= 40)) {
      event.preventDefault();
    }
  });

  // Prevent double-tap zoom
  let lastTouchEnd = 0;
  document.addEventListener('touchend', function(event) {
    const now = new Date().getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);
}


// WEBPACK FOOTER //
// ./scripts/main.js